import { Dialog } from '@headlessui/react';
import { X } from 'lucide-react';
import { LicencaForm } from './LicencaForm';
import type { LicenseDetail } from '../api';

interface Props {
  open: boolean;
  /** Se ausente, é criação. Se presente, edição. */
  initial?: LicenseDetail;
  onClose: () => void;
  /** Chamado após POST/PUT com sucesso — recebe a LicenseDetail salva. */
  onSuccess: (license: LicenseDetail) => void;
}

/**
 * Modal wrapper do LicencaForm. Alinhado com AtivoFormModal — z-40,
 * max-w-3xl, header com X, fechamento por backdrop/ESC via Headless UI.
 *
 * Nota: quando aberto em cima do LicencaDetalheModal (fluxo "Editar"),
 * ambos têm z-40; o Headless UI empilha na ordem de mount, então este
 * vem por cima naturalmente. Se algum dia empilhar mais uma camada,
 * subir o z aqui.
 */
export function LicencaFormModal({ open, initial, onClose, onSuccess }: Props) {
  const isEdit = !!initial;
  return (
    <Dialog open={open} onClose={onClose} className="relative z-40">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-lg bg-white p-6 shadow-xl">
          <div className="mb-4 flex items-center justify-between">
            <Dialog.Title className="text-lg font-semibold text-gray-900">
              {isEdit ? 'Editar licença' : 'Nova licença'}
            </Dialog.Title>
            <button onClick={onClose} className="rounded p-1 text-gray-500 hover:bg-gray-100">
              <X className="h-5 w-5" />
            </button>
          </div>

          <LicencaForm
            license={initial}
            onCancel={onClose}
            onSuccess={(license) => { onSuccess(license); onClose(); }}
          />
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
